export const removeDuplicateObjFromArray = (arr, uploadId) => {
  const duplicate = arr.find(comment => comment.uploadId === uploadId);
  const index = arr.indexOf(duplicate);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};
